import { svgIconFactory } from './icon-factory';

function Swap() {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M9.5 0C4.25329 0 0 4.12857 0 9.22145C0 13.3272 2.76458 16.8056 6.58518 18C6.62339 17.983 6.66942 17.9669 6.72566 17.9533C7.06193 17.8716 7.06193 17.7084 7.06193 17.7084V15.8315C5.71679 16.1579 4.37167 15.6683 4.11946 15.0971C3.86724 14.5258 3.19467 13.5466 3.19467 13.5466C2.26988 13.1385 2.5221 12.8937 2.5221 12.8937C3.36281 12.4857 4.20352 13.5466 4.20352 13.5466C4.20352 13.5466 4.62387 14.3626 5.46458 14.689C6.30529 15.0154 7.14599 14.5258 7.14599 14.5258C7.06191 13.7098 7.65043 13.2201 7.65043 13.2201C6.22123 13.2201 4.00497 12.573 3.53095 10.1191C3.02651 7.50772 4.37165 6.28363 4.37165 6.28363C3.78316 5.22276 4.45573 3.83546 4.45573 3.83546C5.96901 3.83546 7.06193 4.81473 7.06193 4.81473C7.65045 4.48833 9.58408 4.48833 9.58408 4.48833C9.58408 4.48833 11.5177 4.48833 12.1062 4.81475C12.1062 4.81475 13.1991 3.83548 14.7124 3.83548C14.7124 3.83548 15.385 5.22278 14.7965 6.28366C14.7965 6.28366 16.1416 7.50774 15.6372 10.1191C15.1632 12.573 12.9469 13.2201 11.5177 13.2201C11.5177 13.2201 12.0877 13.7059 12.1062 14.5258C12.1136 14.8528 12.1062 15.8315 12.1062 15.8315V17.7085C12.1062 17.7085 12.1062 17.8717 12.4425 17.9533C12.4655 17.9589 12.4866 17.9649 12.5065 17.9712C16.2796 16.7501 19 13.2943 19 9.22147C19 4.12859 14.7467 0 9.5 0Z"
        fill="url(#paint0_linear_659_2769)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_659_2769"
          x1="18.6607"
          y1="18"
          x2="1.02661"
          y2="-0.955069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0050" />
          <stop offset="0.714448" stopColor="#7000FF" />
          <stop offset="1" stopColor="#0027FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const GithubIcon = svgIconFactory(Swap);
